




















import { Component, Vue } from 'vue-property-decorator';
import CLButton from '@/components/CLButton.vue';

@Component({
  name: 'CLHeader',
  components: {
    CLButton,
  },
})
export default class CLHeader extends Vue {
  scrolled: boolean = false;

  created() {
    window.addEventListener('scroll', this.onScroll);
  }

  onScroll() {
    if (window.pageYOffset > 10) {
      this.scrolled = true;
    } else {
      this.scrolled = false;
    }
  }
}
